import qs from 'qs';
import _ from 'lodash'
const serverFormData = require('isomorphic-form-data')

const contentTypeTable = {
    "multipart/form-data" (data, isServer) {
        if (data.constructor.name === 'FormData') return data
        let form = process.server ? new serverFormData() : new FormData()
        Object.keys(data).forEach(x => {
            form.append(x, data[x])
        })
        return form
    },
    "application/x-www-form-urlencoded" (data) {
        return qs.stringify(data)
    },
    "json" (x){ return JSON.stringify(x)},
    default  (data) {
        return qs.stringify(data)
    },
}
export const transDataType = (headers, d, isServer, method) => {
    let ct = _.get(headers, [method, 'Content-Type'])
    if (!ct) return contentTypeTable['multipart/form-data'](d, isServer)
    for (let i in contentTypeTable) {
        if (contentTypeTable.hasOwnProperty(i)) {
            let it = contentTypeTable[i]
            if (ct.search(i)>=0) {
                return it(d, process.server)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./plugins/req/ContentType.js